import { get, getValueByPath, getFullUrl, getRequestParamter, compileData } from '../utils/index'
import { pgMessage } from '../components/index'
import { useRouter } from 'vue-router/composables'
import { getCurrentInstance } from 'vue'

export function useRouterSystem() {
  const router = useRouter()
  const { proxy } = getCurrentInstance()

  /**
   *
   * @param {*} param //{tokenId: tokenId, organizationCode: organizationCode, systemCode: systemCode,}
   * @param {*} url
   * @param {*} routerPath
   * @returns
   */
  const toOtherSystem = async (param, url, routerPath = '') => {
    if (!param.tokenId || !param.systemCode || !url) {
      return
    }
    const [resData] = await get('rest/security/auth/getTicketByToken', param)
    if (resData) {
      const openUrl = getFullUrl(`${url}?ticket=${resData.data}${routerPath}`)
      var win1 = window.open(openUrl)
      if (!win1 || !win1.location) {
        pgMessage.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
      }
    }
  }

  const toSystemOrOrerDetail = (tokenId, itemData, processKey = 'process') => {
    const getWho = getValueByPath(itemData, 'parameter.pathConfig', 'path') //pathConfig: "path" 后台返回的
    const parameter = itemData.parameter //{biz: "入库通知单", coop: "国药集团上海医疗器械有限公司", phone: "", total: "￥180.00", number: "TEST-RKTZ20220100000034",…}
    let webData = itemData[processKey].web //{path: "/warehouse/inboundNotice/detail?id=:orderId&function=401010", system: "ISCC"}
    let path = webData[getWho]
    if (path && typeof parameter === 'object') {
      path = compileData(path, parameter) // 霏哥说统一使用 {{}} 模式配置
      if (path.indexOf(':') > -1) {
        // 兼容老式解析 “:” 写法
        Object.keys(parameter).forEach((im) => {
          const replaceField = ':' + im
          if (path.indexOf(replaceField) > -1) {
            path = path.replace(replaceField, parameter[im])
          }
        })
      }
    }
    let nowSystemCode = proxy.$store.state.user?.CurrentTicket?.system?.code ?? null
    if (!webData || itemData.system.code === nowSystemCode) {
      const routeArr = path.split('?')
      const querys = getRequestParamter(path)
      router.push({
        path: routeArr[0],
        query: {
          ids: itemData.parameter.id,
          ...querys,
        },
      })
    } else {
      const params = {
        tokenId,
        organizationCode: itemData.organization.code,
        systemCode: itemData.system.code,
      }
      toOtherSystem(params, `/${itemData.system.code.toLowerCase()}/index.html`, `#${path}`)
    }
  }
  return {
    toOtherSystem,
    toSystemOrOrerDetail,
  }
}
